const environment = {
  baseUrl: "http://localhost:3008/main/", //"http://localhost:3000",
  api: "http://localhost:8080/api/", //"http://localhost:8080/api",
  csw: "http://localhost:8163/csw/",
  geoserver: "http://localhost:8181/geoserver/", //"http://172.16.3.163:8081/",
};

if (process.env.REACT_APP_ENV === "development") {
  environment.baseUrl = "http://localhost/main/";  // Sesuai dengan WEBSERVER_CONNECTION_PORT=80
  environment.api = "http://localhost:8162/api/";  // Sesuai dengan API_NODE_CONNECTION_PORT=8162
  environment.csw = "http://localhost:8163/csw/";  // Sesuai dengan PYCSW_CONNECTION_PORT=8163
  environment.geoserver = "http://localhost:81/geoserver/";  // Sesuai dengan GEOSERVER_CONNECTION_PORT=81
}

if (process.env.REACT_APP_ENV === "staging") {
  environment.baseUrl = "http://10.88.3.139/main/";
  environment.api = "http://10.88.3.139/api/";
  environment.csw = "http://10.88.3.139/csw/";
  environment.geoserver = "http://10.88.3.139/geoserver/";
}

if (process.env.REACT_APP_ENV === "production") {
  environment.baseUrl = "https://geoportal.jombangkab.go.id/main/";
  environment.api = "https://geoportal.jombangkab.go.id/api/";
  environment.csw = "https://geoportal.jombangkab.go.id/csw/";
  environment.geoserver = "https://geoportal.jombangkab.go.id/geoserver/";
}

export default environment;
